import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbTooltipModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AvatarModule } from 'ngx-avatars';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { CorporateSearchCardComponent } from './corporate-search-card.component';



@NgModule({
  declarations: [CorporateSearchCardComponent],
  imports: [CommonModule, NgbTooltipModule, AvatarModule, NgbModule, PipesModule],
  exports: [CorporateSearchCardComponent]
})
export class CorporateSearchCardModule { }
